import { useMutation, useQueryClient } from 'react-query'
import { AlmanacFileCalendarItem } from './types'
import { calendarKeys } from './calendarKeys'
import { sendToApi } from 'api/client'
import {
  deleteItemProcessor,
  handleMutationError,
  processDateRangeQueries,
  setupMutation,
  updateUnscheduledItems,
} from './utils'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export function useDeleteCalendarItem(projectKey: string) {
  const projectKeys = [projectKey]
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()
  const filters = { projectKeys }

  return useMutation(
    (item: AlmanacFileCalendarItem) => {
      return sendToApi(`/w/${workspaceId}/calendar_items/${item.key}`, { method: 'DELETE' })
    },
    {
      onMutate: async (deletedItem: AlmanacFileCalendarItem) => {
        const context = await setupMutation(queryClient, filters)

        updateUnscheduledItems(queryClient, filters, 'add', deletedItem, context.previousData)
        processDateRangeQueries(queryClient, filters, deleteItemProcessor(deletedItem), context.previousData)

        return context
      },
      onError: (error, variables, context) => handleMutationError(queryClient, error, variables, context),
      onSettled: () => queryClient.invalidateQueries(calendarKeys.filters(filters)),
    },
  )
}
